import {Component, Inject, OnInit, PLATFORM_ID, DOCUMENT} from '@angular/core';
import {CustomerAchDirectCharge} from './customer-ach-direct-charge.action';
import {AppConstants} from '../../../shared/constants/app-constants';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DataManagerService} from '../../../data/services/DataManager/data-manager.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {BankAchChargeModel} from '../../../data/model/ACHChargeModel/achcharge.model';
import {ChargeModel} from '../../../data/model/ChargeModel/charge.model';
import {BankAccountAchModel} from '../../../data/model/BankAchModel/bankaccountAch.model';
import {ActivatedRoute, Router} from '@angular/router';

import {Location} from '@angular/common';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-customer-ach-direct-charge',
    templateUrl: './customer-ach-direct-charge.component.html',
    styleUrls: ['./customer-ach-direct-charge.component.css'],
    animations: [
        trigger('arrowRotate', [
            state('open', style({
                transform: 'rotate(90deg)'
            })),
            state('close', style({
                transform: 'rotate(0deg)'
            })),
            transition('open => close', animate('400ms ease-in-out')),
            transition('close => open', animate('400ms ease-in-out'))
        ]),
        trigger('moreOption', [
            state('open', style({
                height: '*',
                display: 'visible'
            })),
            state('close', style({
                height: '0px',
                display: 'none'
            })),
            transition('open => close', animate('400ms ease-in-out')),
            transition('close => open', animate('400ms ease-in-out'))
        ]),
        trigger('visibilityChanged', [
            state('true', style({ opacity: 1, display: 'block', height: '*' })),
            state('false', style({ opacity: 0, display: 'none', height: '0' })),
            transition('false => true', animate('250ms', style({ height: '*', opacity: 1 }))),
            transition('true => false', animate('250ms', style({ height: '0', opacity: 0 })))
        ]),
    ],
    standalone: false
})
export class CustomerAchDirectChargeComponent extends CustomerAchDirectCharge implements OnInit {

  setEnableAchPayments = false;
  permissionAchUrl: string;
  urlPermissionAch: string;
  accountId: string;
  customer_id: string;
  errorMsg: string;
  topErrorMsg = '';
  keys: string[];
  keys1: string[];
  achForm: UntypedFormGroup;
  currencies = AppConstants.currencyList;
  maxError = false;
  minError = false;
  achcharge: BankAchChargeModel;
  bank_account: BankAccountAchModel;
  total_amount: number;
  customerData: any;
  hasCustomerData: boolean;
  list_transaction_types: { value?: string, ABBR?: string }[];
  defaultTransactionType: string;


  constructor(dataManager: DataManagerService, snackBar: MatSnackBar, private fb: UntypedFormBuilder, router: Router, route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: any, @Inject('LOCALSTORAGE') private localStorage: any, @Inject(DOCUMENT) private document: Document, private _location: Location) {
    super();
    this.dataManager = dataManager;
    this.route = route;
    this.router = router;
    this.urlPermissionAch = '/accounts';
    this.accountId = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_ID));
    this.customer_id = '';
    this.snackBar = snackBar;
    this.achcharge = new ChargeModel();
    this.achcharge.currency = AppConstants.currencyList[0].name;
    this.achcharge.state = null;
    this.achcharge.country = null;
    this.hasCustomerData = false;
    this.bank_account = new BankAccountAchModel();
    const allowedACHtypes = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_ACCOUNT_SETTINGS)) ?
      JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_ACCOUNT_SETTINGS)).allowed_ach_types : '';
    const list_transaction_types = [
      {value: 'Web Initiated (WEB)', ABBR: 'WEB'},
      {value: 'Corporate Cash Disbursement (CCD)', ABBR: 'CCD'},
      {value: 'Prearranged Payment & Deposit (PPD)', ABBR: 'PPD'},
      {value: 'Telephone Initiated Entry (TEL)', ABBR: 'TEL'},
    ];
    if (allowedACHtypes) {
      this.list_transaction_types = list_transaction_types.filter(function (type) {
        return allowedACHtypes.includes(type.ABBR);
      });
    } else {
      this.list_transaction_types = list_transaction_types;
    }
    this.bank_account.transaction_type = this.list_transaction_types[0].ABBR;
    this.defaultTransactionType = this.list_transaction_types[this.list_transaction_types.length - 1].value;
  }

  ngOnInit(): void {

    this.permissionAchUrl = AppConstants.BASE_URL + this.urlPermissionAch + '/' + this.accountId + '?include=enableAchPayments';
    this.getPermissionACHApproved(this.permissionAchUrl);

    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.customer_id = params['id'];
      }
    });
    this.achForm = this.fb.group({
      accountNumber: [{value: '', disabled: true}, [(Validators.maxLength(17) as any), (Validators.minLength(3) as any)]],
      routingNumber: [{value: '', disabled: true}, [(Validators.required as any), (Validators.maxLength(9) as any)]],
      transaction_type: ['', [(Validators.required as any)]],
      amount: ['', [(Validators.required as any), (Validators.maxLength(14) as any), (Validators.min(0.01) as any)]],
      currencyInput: ['', [(Validators.required as any)]],
    });

  }

  cancelBtn() {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        const id = params['id'];
        this.customer_id = id;
        this.router.navigate([`/customer/customer-details`], {queryParams: {id: id}});

      }
    });
  }

  minMaxCheck(amount) {
    amount != null ? amount = Number(document.getElementById('amount')['value']) : amount;
    if (amount < 0.5) {
      this.maxError = false;
      this.minError = true;
    } else {
      this.minError = false;
      this.maxError = false;
    }

    this.total_amount = parseFloat(amount) ? parseFloat(amount) : 0;

    if (this.total_amount >= 1000000) {
      this.maxError = true;
      this.minError = false;
    }
  }

  checkAmount() {
    if (this.achcharge.amount < 0) {
      this.achcharge.amount = 0;
    }
  }

  _keyPress(event: any) {
    const keypressed = event.which || event.keyCode;
    if ((keypressed >= 48 && keypressed <= 57) // digits
      || keypressed === 8 // backspace
      || keypressed === 9 // tab
      || keypressed === 27 // escape
      || keypressed === 46 // delete
      || (keypressed >= 35 && keypressed <= 38) // end, home, Leftarrows
      || (event.key === 'ArrowRight') // RightArrow
    ) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  onlyNumber(event: any) {
    const keypressed = event.which || event.keyCode;

    if ((keypressed >= 48 && keypressed <= 57) // digits
      || keypressed === 8 // backspace
      || keypressed === 9 // tab
      || keypressed === 27 // escape
      || (event.key === 'Delete') // delete
      || (keypressed >= 35 && keypressed <= 38) // end, home, Leftarrows
      || (event.key === 'ArrowRight') // RightArrow
    ) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  print(obj) {
    console.log(obj);
  }

  createAchDirectTransaction() {
    if (this.achForm.invalid) {
      this.achForm.markAllAsTouched();
      return;
    }

    const achBody = {};
    achBody['sec_code'] = this.bank_account.transaction_type;
    achBody['amount'] = (this.achcharge.amount * 100).toFixed();
    achBody['currency'] = 'usd';
    achBody['customer_id'] = this.customer_id;
    achBody['type'] = 'debit';

    this.achPaymentApiCall(achBody);
  }

  protected passResponse(response) {
    this.snackBar
      .open('ACH Payment Successful', 'Close', {
        duration: 2000,
        panelClass: ['success-snackbar']
      });

    this._location.back();
  }

  protected passError(error) {
    this.errorMsg = error.message;
    if (error.code === 500) {
      this.topErrorMsg = error.message.split(':')[1];
    } else {
      this.topErrorMsg = error.errors;
      this.keys = Object.keys(this.topErrorMsg);
      this.keys1 = Object.values(this.topErrorMsg);
      let i;
      let j;
      const name = ['card_number', 'exp_month', 'exp_year', 'name', 'cvv', 'address_line1',
        'address_line2', 'zip', 'card_source', 'amount', 'statement_description', 'charge_description', 'token_id', 'capture',
        'card_source', 'health_care', 'email_receipt', 'tip_amount', 'prescription_amount', 'vision_amount', 'clinic_amount',
        'dental_amount'];
      for (i = 0; i < this.keys.length; i++) {
        for (j = 0; j < name.length; j++) {
          if (this.keys[i].match(name[j])) {
            document.getElementById(name[j]).style.borderColor = '#a94442';
            document.getElementById(name[j] + 1).style.display = 'block';
          }
        }
      }
    }
  }

  assignFlagEnableAchPayments(res) {
    if (res['data']['enableAchPayments']) {
      this.setEnableAchPayments = res['data']['enableAchPayments']['data'][0]['value'] === '1';
    }
  }

  protected getError(error) {
    console.log(error);
  }

}
